module.exports = __webpack_public_path__ + "img/bg-header@3x.79994ef.jpg";